import { requestRole } from "@/services/roleService";
import { AppRole } from "@/config/roles";
import { isSignupRole, SignupRole } from "./policy";

const KEY = "fanjago.pendingRole";

export type PendingRoleDraft = {
  role: SignupRole;
  roleData: Record<string, unknown>;
  documents: Record<string, string>;
  note: string;
};

export function storePendingRole(draft: PendingRoleDraft) {
  sessionStorage.setItem(KEY, JSON.stringify(draft));
}

export function readPendingRole(): PendingRoleDraft | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as PendingRoleDraft;
    if (!isSignupRole(parsed.role) || parsed.role === "fan") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingRole() {
  sessionStorage.removeItem(KEY);
}

/** Submits a role saved at sign-up once a session exists. Leaves the draft if it fails. */
export async function flushPendingRole(): Promise<{ ok: boolean; message?: string }> {
  const draft = readPendingRole();
  if (!draft) return { ok: true };
  try {
    await requestRole(draft.role as AppRole, draft.note, draft.roleData, draft.documents);
    clearPendingRole();
    return { ok: true };
  } catch (error) {
    return { ok: false, message: error instanceof Error ? error.message : "role_request_failed" };
  }
}
